import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { Request } from '../../../Api/Requests/models'
import { BsEnvelopeFill, BsPersonFill, BsTelephoneFill } from 'react-icons/bs'

export const ShowPlayerDataModal = ({ show, onHide, request }: { show: boolean, onHide: () => void, request: Request }) => {
    return (
        <Modal show={show} onHide={onHide} size='lg' centered keyboard={false}>
            <div className="border border-secondary rounded-3 px-4">
                <Modal.Header>
                    <Modal.Title>Datos del jugador <span className='text-primaryy'>{request.Player?.platformUser}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className='d-flex flex-column gap-2'>
                        <div>
                            <BsPersonFill size={20} />  <span className="text-secondary">Nombre: </span>
                            <span>{request.Player?.firstName} {request.Player?.lastName}</span>
                        </div>
                        <div>
                            <BsPersonFill size={20} />  <span className="text-secondary"> Usuario: </span>
                            <span>{request.Player?.platformUser}</span>
                        </div>
                        <div>
                            <BsEnvelopeFill size={20} />  <span className="text-secondary"> Email: </span>
                            <span>{request.Player?.email}</span>
                        </div>
                        <div>
                            <BsTelephoneFill size={20} />  <span className="text-secondary"> Teléfono: </span>
                            <span>{request.Player?.phone}</span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-end w-100'>
                        <Button variant="secondary" onClick={onHide}>
                            Cerrar
                        </Button>
                    </div>
                </Modal.Footer>
            </div >
        </Modal >
    )
}
